import { AbstractControl, FormGroup } from "@angular/forms";

export function getControlName(control: AbstractControl): string | null {
  const formGroup: FormGroup = control.parent as FormGroup;
  return (
    Object.keys(formGroup?.controls ?? {}).find(
      (name) => control === formGroup.controls[name]
    ) || null
  );
}
